import { render, staticRenderFns } from "./DeptTreeSelect.vue?vue&type=template&id=da840802&scoped=true"
import script from "./DeptTreeSelect.vue?vue&type=script&lang=js"
export * from "./DeptTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./DeptTreeSelect.vue?vue&type=style&index=0&id=da840802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da840802",
  null
  
)

export default component.exports